export const areItemsEqual = <T>(a: T | T[] | undefined, b: T | T[] | undefined) => {
  if (!a || !b) {
    return false;
  }

  return JSON.stringify(recursiveSortWhenAvailable(a)) !== JSON.stringify(recursiveSortWhenAvailable(b));
};

const isObject = (x: unknown): boolean => typeof x === 'object' && !Array.isArray(x) && x !== null;
const isArray = (x: unknown): boolean => Array.isArray(x);

const recursiveSortWhenAvailable = (item: unknown | unknown[]) => {
  if (isObject(item)) {
    return Object.keys(item as object)
      .sort()
      .reduce((acc, key) => {
        const keyValue = (item as object)[key];
        acc[key] = recursiveSortWhenAvailable(keyValue);
        return acc;
      }, {});
  }

  if (isArray(item)) {
    return (item as unknown[]).sort().map(recursiveSortWhenAvailable);
  }

  return item;
};
